import { j as s } from "../../../../jsx-runtime-CQ7OqOhn.js";
import * as t from "@radix-ui/react-select";
const l = ({
  children: o,
  direction: e
}) => {
  const r = e === "up" ? t.ScrollUpButton : t.ScrollDownButton;
  return /* @__PURE__ */ s.jsx(r, { className: "flex h-[25px] cursor-default items-center justify-center bg-surface hover:bg-secondary-hover", children: o });
};
export {
  l as default
};
